var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`benefit-notification-box-base ${_vm.color}`},[_c('img',{staticClass:"icon",attrs:{"src":require(`@/assets/${_vm.iconPath}`)}}),_vm._v(" "),_c('div',{staticClass:"text-container"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{},[_vm._v(_vm._s(_vm.description))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }